/**
 * Galeria Produto Bodie — troca slides e pausa vídeos ao mudar de miniatura.
 */
(function () {
  function pauseMediaInSlide(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (v) {
      try {
        v.pause();
      } catch (e) {}
    });
  }

  document.querySelectorAll('[data-produto-bodie-gallery]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-produto-slide]');
    var thumbs = root.querySelectorAll('[data-produto-thumb]');
    if (!slides.length || !thumbs.length) return;

    function show(index) {
      slides.forEach(function (slide, j) {
        var on = j === index;
        slide.classList.toggle('is-active', on);
        if (on) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
          pauseMediaInSlide(slide);
        }
      });
      thumbs.forEach(function (btn, j) {
        var on = j === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        show(i);
      });
    });
  });
})();
